var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1CallBlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 76"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 16.4l-3-2.6-11.8 13.4 4.4 3.8a69.5 69.5 0 01-6.8 9.1 77.7 77.7 0 01-8.2 8l-4.4-3.9-11.7 13.4 3 2.6a3.8 3.8 0 003.7.7h.1l.5-.2c6.1-2.9 14.9-9.9 21.1-16.9s12.1-16.7 14.1-23.1a1.3 1.3 0 00.1-.6.1.1 0 00.1-.1 4 4 0 00-1.2-3.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 18.4A11.3 11.3 0 1039 29.7a11.3 11.3 0 00-11.3-11.3zM35 29.7a6.8 6.8 0 01-.9 3.5l-10-9.9A7.4 7.4 0 0135 29.7zm-14.6 0a7.4 7.4 0 01.9-3.6l9.9 10a6.8 6.8 0 01-3.5.9 7.3 7.3 0 01-7.3-7.3z"
  })));
}
export default __webpack_public_path__ + "static/media/H1_Call_blocked.148059f2.svg";
export { SvgH1CallBlocked as ReactComponent };